var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPasswordCloseDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.02588 8.87195C3.92334 10.393 4.78413 11.2681 5.91378 12.0929M5.91378 12.0929C7.13043 12.9789 8.60118 13.3701 10.0267 13.6822M5.91378 12.0929L4.52606 13.8954M21.0281 8.87195C20.0113 10.6672 19.2657 11.2133 18.136 12.038M18.136 12.038C16.9194 12.9241 15.4528 13.3701 14.0272 13.6822M18.136 12.038L19.5279 13.8954M10.0267 13.6822L9.52667 16.1281M10.0267 13.6822C11.3481 13.9656 12.7058 13.9656 14.0272 13.6822M14.0272 13.6822L14.5273 16.1281",
    stroke: "white",
    strokeWidth: 1.68171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordCloseDark);
export default __webpack_public_path__ + "static/media/Password Close Dark.6518de435d65e22d145c2f585935c431.svg";
export { ForwardRef as ReactComponent };